import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from '../styles';

const NavLink = ({ to, children }) => {
  const [hovered, setHovered] = useState(false);
  const location = useLocation();
  const active = location.pathname === to;

  return (
    <Link
      to={to}
      style={{ ...styles.navItem, display: 'inline-block' }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {children}
      <span
        style={{
          position: 'absolute',
          width: hovered || active ? '100%' : '0',
          height: '2px',
          bottom: '-4px',
          left: '0',
          backgroundColor: '#1B2B3E',
          transition: 'width 0.3s cubic-bezier(0.25, 1, 0.5, 1)',
        }}
      />
    </Link>
  );
};

const Nav = () => {
  return (
    <nav style={styles.nav}>
      <div
        className="nav-inner"
        style={{
          ...styles.container,
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Link to="/">
          <img
            src="/logo.png"
            alt="FCR Credit Solutions"
            style={{ height: '40px', display: 'block' }}
          />
        </Link>
        <div className="nav-links" style={styles.navLinks}>
          <NavLink to="/process">Process</NavLink>
          <NavLink to="/contact">Contact</NavLink>
          <a
            href="https://securecreditaccess.com/"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              ...styles.navItem,
              display: 'inline-block',
            }}
          >
            Client Portal
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Nav;
